import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeaveManagementRoutingModule } from './leave-management-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { AppMaterialModule } from 'src/app/app-material.module';
import { HolidayCalendarComponent } from './holiday-calendar/holiday-calendar.component';
import { LeaveAprvlRejectionComponent } from './leave-aprvl-rejection/leave-aprvl-rejection.component';
import { CompOffMngmntComponent } from './comp-off-mngmnt/comp-off-mngmnt.component';
import { EmplyLeaveBalanceComponent } from './emply-leave-balance/emply-leave-balance.component';
import { UserLeaveAtndceComponent } from './user-leave-atndce/user-leave-atndce.component';
import { AgmCoreModule } from "@agm/core";
import { EmployeeLeaveReportComponent } from './employee-leave-report/employee-leave-report.component';


@NgModule({
  declarations: [
    HolidayCalendarComponent,
    LeaveAprvlRejectionComponent,
    CompOffMngmntComponent,
    EmplyLeaveBalanceComponent,
    UserLeaveAtndceComponent,
    EmployeeLeaveReportComponent
  ],
  imports: [
    CommonModule,
    LeaveManagementRoutingModule,
    ReactiveFormsModule,
    DataTablesModule,
    FormsModule,
    NgbModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule,
    TimepickerModule.forRoot(),
    AppMaterialModule,
    AgmCoreModule
],
})
export class LeaveManagementModule {}
